import React from "react";
import { toast } from "react-toastify";

const OrderRow = ({ order, index, refetch }) => {
  const {
    _id,
    product_image,
    product_name,
    product_price,
    product_quantity,
    customer_name,
    mobile_number,
    address,
    order_status,
  } = order;

  const handleConfirmOrder = () => {
    fetch(`https://evening-peak-35730.herokuapp.com/confirmOrder/${_id}`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.modifiedCount > 0) {
          refetch();
          toast.success("Successfully Confirm Order. Alhamdulillah!");
        }
      });
  };
  const handleCompleteOrder = () => {
    fetch(`https://evening-peak-35730.herokuapp.com/completeOrder/${_id}`, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.modifiedCount > 0) {
          refetch();
          toast.success("Successfully Complete Order. Alhamdulillah!");
        }
      });
  };

  return (
    <tr>
      <th>{index + 1}</th>
      <td>
        <div class="avatar">
          <div class="w-24 mask mask-squircle">
            <img src={product_image} alt="brand_image" />
          </div>
        </div>
      </td>
      <td>{product_name}</td>
      <td>{product_price}</td>
      <td>{product_quantity}</td>
      <td>{customer_name}</td>
      <td>{mobile_number}</td>
      <td>{address}</td>
      <td>
        {order_status === "pending" && (
          <button
            onClick={handleConfirmOrder}
            className="btn btn-sm btn-primary"
          >
            Confirm Order
          </button>
        )}
        {order_status === "confirm" && (
          <button
            onClick={handleCompleteOrder}
            className="btn btn-sm btn-neutral"
          >
            Delivered
          </button>
        )}
        {order_status === "delivered" && (
          <label for="productDeleteModel" className="btn btn-sm btn-secondary">
            Delete
          </label>
        )}
      </td>
    </tr>
  );
};

export default OrderRow;
